export class SearchRequestEntity {

	public get Query() { return this.query; }
	public get RecaptchaToken() { return this.recaptchaToken; }
	public get RequestVerificationToken() { return this.requestVerificationToken; }

	constructor(private query: string, private recaptchaToken: string, private requestVerificationToken: string){}
}